import icon from "../../assets/port-count.svg";
import type { Property } from "../../types";

export const ports: Property = {
  id: "ports",
  title: "ports.title",
  icon,
};
